import { WatchQueryFetchPolicy } from "@apollo/client";

export const mainApiConfig = {
    endpoint: '/graphql',
    blobUploadEndpoint: '/api/blobs',
    defaultFetchPolicy: 'cache-and-network' as WatchQueryFetchPolicy,
    //defaultFetchPolicy: 'cache-first' as WatchQueryFetchPolicy,
};